import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileSection2 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const section2 = this.props.form.Section2;

        return (
            <div className="section border border-bottom bc-antenatal-section-part1">
                <div className="row row-form section-row">
                    <div className="section-column-1">
                        <div className="flex-display flex-space-between label-max-height-20 flex-col-gap-xs">
                            {this.renderMultipleLabel(
                                "AllergiesLabel",
                                this.getTitleNumberAsLabelPrefix(2),
                                this.getLabelSuffix(this.getString("ObstetricalFile_InclReactionLabel"), "extra-info-label")
                            )}
                            {this.controlRenderer.renderCheckbox(
                                "NoneWordLabel",
                                section2.HasNoAllergies,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Section2.HasNoAllergies = value)
                            )}
                        </div>
                        {this.controlRenderer.renderResizableTextarea({
                            value: section2.Allergies,
                            onChange: value => this.props.mutateModelState(s => s.Section2.Allergies = value),
                            className: "textarea-padding",
                            minHeight: "34px"
                        })}
                    </div>
                    <div className="section-column-1">
                        {this.renderField({
                            label: "ObstetricalFile_MedicationsOtcDrugsLabel",
                            field: this.controlRenderer.renderResizableTextarea({
                                value: section2.Medications,
                                onChange: value => this.props.mutateModelState(s => s.Section2.Medications = value),
                                className: "textarea-padding",
                                minHeight: "34px"
                            })
                        })}
                    </div>
                    <div className="column-width-16 flex-align-items-center">
                        {this.controlRenderer.renderCheckbox(
                            "ObstetricalFile_PreconceptionFolicAcidLabel",
                            section2.HasPreconceptionFolicAcid,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section2.HasPreconceptionFolicAcid = value)
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "ObstetricalFile_T1FolicAcidLabel",
                            section2.HasT1FolicAcid,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section2.HasT1FolicAcid = value)
                        )}
                    </div>
                    <div className="column-width-24 flex-display">
                        {this.renderField({
                            label: "ObstetricalFile_BeliefsPracticesLabel",
                            field: this.controlRenderer.renderTextbox({
                                value: section2.BeliefsPractices,
                                onChange: value => this.props.mutateModelState(s => s.Section2.BeliefsPractices = value),
                                maxLength: this.page1FieldLimits.BeliefsPractice.MaxChars
                            }),
                            className: "width-100",
                            labelSuffix: this.getLabelSuffix(this.getString("ObstetricalFile_ForExampleJehovahWitnessLabel"), "extra-info-label"),
                            labelClassName: "inline-flex-center flex-wrap flex-col-gap-xs"
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileSection2 };
